import { captureException } from "@sentry/nextjs";

import { DEFAULT_ENDPOINT } from "utils/web3/endpoints";

export async function fetchUsersVotingPower(
  wallet: string
): Promise<number | undefined> {
  try {
    const isDevnet = DEFAULT_ENDPOINT.name === "devnet";
    const response = await fetch(
      `https://snapshots-api${
        isDevnet ? "-dev" : ""
      }.marinade.finance/v1/snapshot/latest/vemnde/${wallet}`
    );

    if (!response.ok) {
      return undefined;
    }

    const result = await response.json();
    return Number(result.amount);
  } catch (err) {
    captureException(err);
    return undefined;
  }
}
